"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Luggagex2 = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Luggagex2 = function Luggagex2(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 .757C5 .339 5.451 0 5.99 0h4.02c.546 0 .99.333.99.757V3h3.496C15.326 3 16 3.805 16 4.795v8.41c0 .992-.673 1.795-1.504 1.795H1.504C.674 15 0 14.195 0 13.205v-8.41C0 3.803.673 3 1.504 3H5V.757zM6 3h4V1H6v2zm7.342 9h-4.78v-.815l2.368-2.583c.341-.381.584-.699.727-.953a1.54 1.54 0 00.22-.771c0-.339-.096-.612-.288-.82-.189-.209-.444-.313-.767-.313-.384 0-.682.117-.893.352-.212.234-.318.555-.318.962H8.425c0-.433.097-.822.293-1.167a2.05 2.05 0 01.845-.811 2.703 2.703 0 011.269-.288c.69 0 1.234.174 1.63.522.401.345.601.824.601 1.436 0 .355-.1.728-.302 1.118-.199.388-.526.829-.982 1.323l-1.738 1.86h3.3V12zM5.505 8.455L6.51 6.717h1.318L6.213 9.319 7.883 12H6.574L5.52 10.193 4.47 12H3.15l1.67-2.68-1.61-2.604h1.309l.986 1.738z",
    fill: "currentColor"
  }));
};

exports.Luggagex2 = Luggagex2;
var _default = Luggagex2;
exports.default = _default;